import React from "react";
import styled from "styled-components";
import ReactPlayer from "react-player/youtube";

import Header from "../components/Header";
import Footer from "../components/Footer";

const Container = styled.div`
  display: flex;
  min-height: calc(100vh);
  height: 100vh;
  flex-direction: column;
  overflow: scroll;
  position: relative;
  @media screen and (max-width: 1024px) {
    width: 100%;
    margin: 0;
  }
`;
const Wrapper = styled.div`
  width: 1200px;
  margin: 96px auto;
  height: 100%;
  @media screen and (max-width: 1024px) {
    width: 100%;
  }
  & > div {
    padding: 20px 10rem 0;
    @media screen and (max-width: 320px) {
      padding: 0 1rem 0;
    }
    @media screen and (max-width: 425px) and (min-width: 321px) {
      padding: 0 3rem 0;
    }
    @media screen and (max-width: 768px) and (min-width: 426px) {
      padding: 0 5rem 0;
    }
  }
`;
const Text = styled.p`
  color: #315c89;
  font-weight: 400;
  font-size: 20px;
`;
/* const Flex = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  & > img {
    margin-right: 20px;
  }
`; */
const Link = styled.a`
  text-decoration: none;
  display: flex;
  align-items: center;
  width: max-content;
  margin: 20px 0;
  & > img {
    margin-right: 20px;
  }
`;
const PlayerContainer = styled.div`
  position: relative;
  padding-top: 56.25%; /* 720 / 1280 = 0.5625 */
  width: 100%;
`;

const ReactPlayerStyled = styled(ReactPlayer)`
  position: absolute;
  width: 100% !important;
  height: 100% !important;
  top: 0;
  left: 0;
`;
function Presentation() {
  return (
    <>
      <Container>
        <Header />
        <Wrapper>
          <div>
            {" "}
            <div style={{ marginBottom: "50px" }}>
              <Text>
                Kanal İstanbul, konumu, işlevi ve etki alanıyla Türkiye'nin
                stratejik hamlesidir.
              </Text>
              <Text>
                İstanbul Boğazı’nın maruz kaldığı riski minimize edecek Kanal
                İstanbul, Türkiye'yi bölgesinin lojistik üssü haline getirirken
                Marmarayı'da Avrasya'nın merkezi yapacak.
              </Text>
              <Text>
                Kanal İstanbul, dünyanın en büyük projelerinden biri olmasının
                yanında Türkiye’nin de vizyon projesidir.
              </Text>
            </div>
            <PlayerContainer>
              <ReactPlayerStyled url="https://www.youtube.com/embed/kb6YrYnjOVQ" />
            </PlayerContainer>
          </div>
        </Wrapper>
        <Footer />
      </Container>
    </>
  );
}
export default Presentation;
